import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../../hooks";
import { usePromptFormContext } from "../../context/PromptFormContext";
import { ChatComponent } from "../ChatComponent";
import { Typography } from "@ann/web-components";
import { InitialPromptWrapper } from "../../pages/PmsPromptConfigPage/pages/PromptPage/PromptPage.styled";
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import {
  PromptCreateViewContainer,
  LeftColumn,
  LoadingContainer,
  CustomSpinner,
} from "./PromptCreateView.styled";

const PromptCreateView = observer(() => {
  const { authStore, editAgent } = useStore();
  const { 
    handlePromptMetadata, 
    setPromptConfigureMetadata,
    promptConfigureMetadata 
  } = usePromptFormContext();

  useEffect(() => {
    setPromptConfigureMetadata();
  }, [setPromptConfigureMetadata]);

  const creatorAgents = editAgent.agents.filter(agent => agent.domain === 'creator');
  const selectedCreatorAgent = creatorAgents[0] || null;

  const promptCreateInitialContent = (
    <InitialPromptWrapper>
      <ChatBubbleOutlineRoundedIcon color="primary"/>
      <Typography
        category="title"
        size="medium"
        weight="bold"
      >
        Build your prompt with AI guidance
      </Typography>
      <Typography
        category="body"
        size="large"
        weight="regular"
      >
        Just start typing what you want your prompt to do. We'll guide you step by<br/>step to help you create a custom prompt—no forms required.
      </Typography>
    </InitialPromptWrapper>
  );

  if (!editAgent.finishedInitialLoad) {
    return (
      <PromptCreateViewContainer>
        <LeftColumn>
          <LoadingContainer>
            <CustomSpinner />
          </LoadingContainer>
        </LeftColumn>
      </PromptCreateViewContainer>
    );
  }

  return (
    <PromptCreateViewContainer>
      <LeftColumn>
        {selectedCreatorAgent ? (
          <ChatComponent
            customerSelected={authStore.selectedAccount.id}
            agentId={selectedCreatorAgent.id}
            agentDomain={'creator'}
            inputWidth="80vh"
            metadata={promptConfigureMetadata}
            handleMetadata={handlePromptMetadata}
            agentData={{
              id: selectedCreatorAgent.id,
              customerId: selectedCreatorAgent.customer_id,
              jobTitle: selectedCreatorAgent.job_title || "",
              persona: selectedCreatorAgent.persona || { name: "" },
              tone: selectedCreatorAgent.tone || [],
              conversationStarters: selectedCreatorAgent.conversation_starters || [],
              extendedAnswer: selectedCreatorAgent.extended_answer || false,
              scope: selectedCreatorAgent.scope || "",
              actions: selectedCreatorAgent.actions || [],
              actionsSettings: selectedCreatorAgent.actions_settings || [],
              name: "Prompt Creator",
              knowledgeBase: selectedCreatorAgent.knowledge_base || [],
              humanInstructions: selectedCreatorAgent.human_instructions || "",
              prompt: selectedCreatorAgent.prompt || "",
              addToConcierge: selectedCreatorAgent.add_to_concierge || false,
              channels: selectedCreatorAgent.channels || [],
              fullInstructions: selectedCreatorAgent.full_instructions || "",
              guardrails: selectedCreatorAgent.guardrails || [],
              features: selectedCreatorAgent.features || [],
              instructionRef: selectedCreatorAgent.instruction_ref || [],
              status: selectedCreatorAgent.status || "draft",
              photoUrl: selectedCreatorAgent.photo_url || "",
              model: selectedCreatorAgent.model || "",
              category: selectedCreatorAgent.category || "",
              signature: selectedCreatorAgent.signature || { EMAIL: "" },
              type: selectedCreatorAgent.type || "",
              promptId: selectedCreatorAgent.prompt_id || "",
              createdBy: selectedCreatorAgent.created_by || ""
            }}
            initialContent={promptCreateInitialContent}
          />
        ) : (
          <LoadingContainer>
            <Typography category="title" size="medium" weight="bold">
              No creator agent found
            </Typography>
          </LoadingContainer>
        )}
      </LeftColumn>
    </PromptCreateViewContainer>
  );
});

export default PromptCreateView;
